export default __webpack_public_path__ + "static/media/1810.813d6617.png";